import styles from "./MockRota.module.css";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const;
const HOURS = [6, 8, 10, 12, 14, 16, 18, 20] as const;

interface Shift {
  readonly day: number;
  readonly startHour: number;
  readonly endHour: number;
  readonly color: string;
}

interface Cleaner {
  readonly name: string;
  readonly shifts: readonly Shift[];
}

const CLEANERS: readonly Cleaner[] = [
  {
    name: "Sarah M.",
    shifts: [
      { day: 0, startHour: 6, endHour: 14, color: "var(--color-accent-solid)" },
      { day: 1, startHour: 6, endHour: 14, color: "var(--color-accent-solid)" },
      { day: 2, startHour: 6, endHour: 12, color: "var(--color-accent-solid)" },
      { day: 3, startHour: 6, endHour: 14, color: "var(--color-accent-solid)" },
      { day: 4, startHour: 6, endHour: 14, color: "var(--color-accent-solid)" },
    ],
  },
  {
    name: "James K.",
    shifts: [
      { day: 0, startHour: 14, endHour: 20, color: "var(--color-info-solid)" },
      { day: 1, startHour: 14, endHour: 20, color: "var(--color-info-solid)" },
      { day: 2, startHour: 14, endHour: 20, color: "var(--color-info-solid)" },
      { day: 3, startHour: 14, endHour: 20, color: "var(--color-info-solid)" },
      { day: 5, startHour: 8, endHour: 16, color: "var(--color-info-solid)" },
    ],
  },
  {
    name: "Priya S.",
    shifts: [
      { day: 0, startHour: 8, endHour: 16, color: "var(--color-warning-solid)" },
      { day: 2, startHour: 12, endHour: 20, color: "var(--color-warning-solid)" },
      { day: 4, startHour: 8, endHour: 16, color: "var(--color-warning-solid)" },
      { day: 5, startHour: 8, endHour: 16, color: "var(--color-warning-solid)" },
    ],
  },
  {
    name: "David O.",
    shifts: [
      { day: 1, startHour: 6, endHour: 14, color: "#8b5cf6" },
      { day: 3, startHour: 6, endHour: 14, color: "#8b5cf6" },
      { day: 4, startHour: 14, endHour: 20, color: "#8b5cf6" },
      { day: 6, startHour: 8, endHour: 16, color: "#8b5cf6" },
    ],
  },
  {
    name: "Ayo T.",
    shifts: [
      { day: 0, startHour: 10, endHour: 18, color: "#ec4899" },
      { day: 2, startHour: 6, endHour: 14, color: "#ec4899" },
      { day: 3, startHour: 14, endHour: 20, color: "#ec4899" },
      { day: 5, startHour: 10, endHour: 18, color: "#ec4899" },
    ],
  },
];

const TOTAL_HOURS = 14;
const START_HOUR = 6;

function shiftPosition(shift: Shift) {
  const left = ((shift.startHour - START_HOUR) / TOTAL_HOURS) * 100;
  const width = ((shift.endHour - shift.startHour) / TOTAL_HOURS) * 100;
  return { left: `${left}%`, width: `${width}%` };
}

export function MockRota() {
  return (
    <div className={styles.rota} aria-hidden="true">
      <div className={styles.header}>
        <div className={styles.cornerCell} />
        {DAYS.map((day) => (
          <div key={day} className={styles.dayHeader}>
            {day}
          </div>
        ))}
      </div>

      <div className={styles.timeAxis}>
        <div className={styles.cornerCell} />
        {HOURS.map((hour) => (
          <span key={hour} className={styles.timeLabel}>
            {hour.toString().padStart(2, "0")}:00
          </span>
        ))}
      </div>

      <div className={styles.body}>
        {CLEANERS.map((cleaner) => (
          <div key={cleaner.name} className={styles.cleanerRow}>
            <div className={styles.cleanerName}>{cleaner.name}</div>
            <div className={styles.shiftCells}>
              {DAYS.map((_, dayIndex) => {
                const dayShifts = cleaner.shifts.filter(
                  (s) => s.day === dayIndex,
                );
                return (
                  <div key={dayIndex} className={styles.dayCell}>
                    {dayShifts.map((shift, shiftIndex) => {
                      const pos = shiftPosition(shift);
                      return (
                        <div
                          key={shiftIndex}
                          className={styles.shiftBlock}
                          style={{
                            left: pos.left,
                            width: pos.width,
                            backgroundColor: shift.color,
                          }}
                        />
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
